export type CampaignListFilters = {
  name?: string;
  status?: string | null;
  createdFrom?: string | null;
  createdTo?: string | null;
};

export type GetCampaignsPayload = CampaignListFilters & {
  limit?: number;
  offset?: number;
};

export enum CampaignStatus {
  pending = "pending",
  completed = "completed",
  failed = "failed",
}

export const colorByStatus = {
  [CampaignStatus.completed]: "green",
  [CampaignStatus.pending]: "blue",
  [CampaignStatus.failed]: "red",
};

export type Campaign = {
  id: string;
  name: string;
  category: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  createdByEmail: string;
  status: CampaignStatus;
};

export type CampaignDetails = Campaign & {
  statistics: {
    total: number;
    pending: number;
    failed: number;
    completed: number;
    minSimilarity: number;
    maxSimilarity: number;
    avgSimilarity: number;
    topDomains: string[];
    domainsCount: number;
  };
  tasks: {
    originalUrl: string;
    date: string;
    id: string;
    similaritiesCount: number;
    similaritiesUrls: string[];
  }[];
};

export type GetCampaignsResponse = {
  data: Campaign[];
  meta: {
    total: number;
  };
};

export type CreateCampaignPayload = {
  name: string;
  category: string;
  articles: {
    url: string;
    date?: Date;
    skipCutLongSentences?: boolean;
  }[];
};

export type CreateCampaignResponse = {
  id: string;
};

export type CampaignError = {
  id: string;
  title: string;
  message: string;
};
